import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Validador } from '../models/validador-model';

@Injectable({
  providedIn: 'root'
})
export class ValidadorServiceService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) { }

  getValidadores(): Observable<Validador[]> {
    return this.http.get<Validador[]>(`${this.baseUrl}api/Validador/`);
  }

  getValidadorById(id: number) {
    return this.http.get(`${this.baseUrl}api/Validador/${id}`);
  }

  put(item): Observable<Validador> {
    const url = `${this.baseUrl}api/Validador/${item.id}`;
    console.log("put: "+url);
    return this.http.put<Validador>(url, item);
  }

  post(item): Observable<Validador> {
    const url = `${this.baseUrl}api/Validador`;
    console.log("post: "+url);
    return this.http.post<Validador>(url, item);
  }

  delete(id: number) {
    const url = `${this.baseUrl}api/Validador/${id}`;
    return this.http.delete<Validador>(url);
  }
}
